import styled from "styled-components";

export const AiNavigatorOutcomes = styled.div`
  padding: 15px 20px 0px 20px;
  .header-options {
    &__section {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 17px;
    }
    .principal-selects-container {
      background-color: #F0F0FF;
      border-radius: 12px;
      padding: 10px;
      .select-container {
        &__label {
          font-family: Nunito Sans;
          font-size: 15px;
          margin-left: 12px;
        }
      }
    }
    .right-buttons {
      display: flex;
    }
    .update-outcome-button {
      margin-left: 10px;
      &__button {
        display: flex;
        padding: 6.5px 10px;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        background-color: #36369B;
        color: #FFF;
        font-family: "Nunito Sans";
        font-size: 13px;
        font-style: normal;
        outline: none;
        border: none;
        cursor: pointer;
      }
      &__icon {
        font-size: 10px;
        margin-left: 5px;
      }
    }
    .filter-buttons-container {
      display: flex;
      align-items: center;
      .highlights-button {
        margin-right: 10px;
        cursor: pointer;
        display: flex;
        border: 1px solid #AAAADB;
        align-items: center;
        padding: 8.25px 8.5px;
        border-radius: 60px;
        color: #36369B;
        &--active {
          padding: 8.25px 8.5px;
          color: white;
          border: none;
          background-color: #FFA800;
        }
      }
      .event-type-select {
        .input-container {
          width: 270px;
        }
      }
    }
  }
  .header {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* align-items: flex-end; */
    /* align-items: center; */
    &__left {
      .title {
        margin-left: 14px;
        display: flex;
        align-items: center;
        color: #38379C;
        &__icon {
          font-size: 29px;
          margin-right: 10px;
        }
        &__text {
          font-family: "Nunito Sans Bold";
          font-size: 30px;
        }
      }
    }
    &__right {
      display: flex;
      
      .select-program {
        display: flex;
        flex-direction: column;
        justify-content: center;
        /* align-items: center; */
        &__label {
          color: #3E3E5B;
          font-family: "Nunito Sans Light";
          font-size: 19px;
          margin-bottom: 6px;
        }
        &__select-container {
          width: 320px;
        }
      }
    }
  }
  .process-tabs {
    &__title {
      font-family: Nunito Sans Bold;
      margin-top: 10px;
      font-size: 18px;
      color: #68688D;
    }
    &__process-name {
      font-family: Nunito Sans Bold;
      font-size: 28.15px;
      color: #68688D;
    }
    &__list {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      .process-tab {
        border-radius: 10px;
        background: #F0F0FF;
        display: flex;
        padding: 10px;
        justify-content: center;
        color: #6C6BCC;
        text-shadow: 0px 0px 6px rgba(247, 246, 255, 0.69);
        font-family: "Nunito Sans";
        font-size: 17px;
        margin-right: 10px;
        cursor: pointer;
        &--selected {
          color: #36369B;
          font-family: "Nunito Sans Bold";
          font-size: 17px;
          border-radius: 10px;
          background: #D2D2FF;
          box-shadow: 0px 4px 18.5px -3px rgba(0, 0, 255, 0.06) inset;
        }
      }
    }
  }
  .outcomes-content{
    margin-top: 20px;
  }

`